import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { WatcherrAuthNError, WatcherrError, WatcherrNetworkError } from '@ixicare/resources';
import { notifySessionExpired } from './sessionExpiry';

// A 401 means the session is gone — expired, or revoked by an admin force logout.
// Without this the request simply rejects and any screen that only renders a spinner
// while loading keeps spinning forever, which is what a forced logout used to look
// like. A network failure is deliberately not treated this way: the server being
// unreachable says nothing about whether the session is still valid.
const handleError = (error: unknown): void => {
  if (error instanceof WatcherrAuthNError) {
    notifySessionExpired();
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleError }),
  mutationCache: new MutationCache({ onError: handleError }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: WatcherrError) => {
        if (failureCount < 3 && error instanceof WatcherrNetworkError) {
          return true;
        }
        return false;
      },
    },
  },
});
